export var RTDBPaths;
(function (RTDBPaths) {
    RTDBPaths["Games"] = "games";
    RTDBPaths["Cards"] = "cards";
    RTDBPaths["Connections"] = "connections";
    RTDBPaths["Statuses"] = "statuses";
})(RTDBPaths || (RTDBPaths = {}));
